export default __webpack_public_path__ + "static/media/MarkW05-Bold.3fb0f5d7.woff2";